import React from 'react';

export function PlayMarketIcon() {
  return (
    <svg width="126" height="36" viewBox="0 0 126 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M121.333 36H4.66667C2.10117 36 0 33.9739 0 31.5V4.5C0 2.02613 2.10117 3.8147e-06 4.66667 3.8147e-06H121.333C123.899 3.8147e-06 126 2.02613 126 4.5V31.5C126 33.9739 123.899 36 121.333 36Z"
        fill="black"
      />
      <path
        d="M121.333 0.721127C123.494 0.721127 125.252 2.4165 125.252 4.5V31.5C125.252 33.5835 123.494 35.2789 121.333 35.2789H4.66667C2.506 35.2789 0.747833 33.5835 0.747833 31.5V4.5C0.747833 2.4165 2.506 0.721127 4.66667 0.721127H121.333ZM121.333 3.8147e-06H4.66667C2.10117 3.8147e-06 0 2.02613 0 4.5V31.5C0 33.9739 2.10117 36 4.66667 36H121.333C123.899 36 126 33.9739 126 31.5V4.5C126 2.02613 123.899 3.8147e-06 121.333 3.8147e-06Z"
        fill="#A6A6A6"
      />
      <path
        d="M9.73947 6.78575C9.46531 7.0625 9.30664 7.49338 9.30664 8.05137V27.9549C9.30664 28.5129 9.46531 28.9437 9.73947 29.2205L9.80714 29.2812L21.3735 18.1325V17.8693L9.80714 6.7205L9.73947 6.78575Z"
        fill="url(#paint0_linear_3029_115129)"
      />
      <path
        d="M25.2242 21.8496L21.373 18.1315V17.8682L25.2289 14.1501L25.3152 14.1985L29.8815 16.7039C31.1847 17.4149 31.1847 18.5849 29.8815 19.3004L25.3152 21.8012L25.2242 21.8496Z"
        fill="url(#paint1_linear_3029_115129)"
      />
      <path
        d="M25.3164 21.8012L21.3742 17.9999L9.74023 29.2195C10.1731 29.6582 10.8789 29.7111 11.6816 29.2724L25.3164 21.8012Z"
        fill="url(#paint2_linear_3029_115129)"
      />
      <path
        d="M25.3164 14.1986L11.6816 6.7275C10.8789 6.29325 10.1731 6.34613 9.74023 6.78488L21.3742 18L25.3164 14.1986Z"
        fill="url(#paint3_linear_3029_115129)"
      />
      <path
        d="M44.2564 9.22056C44.2564 9.97206 44.023 10.5739 43.5634 11.0228C43.0349 11.5549 42.3465 11.8227 41.503 11.8227C40.6969 11.8227 40.0085 11.5504 39.4439 11.0138C38.878 10.4693 38.5957 9.80106 38.5957 9.00119C38.5957 8.20131 38.878 7.53306 39.4439 6.99306C40.0085 6.45194 40.6969 6.17969 41.503 6.17969C41.9044 6.17969 42.287 6.25956 42.6522 6.40806C43.0162 6.55769 43.3125 6.76019 43.5272 7.00994L43.0395 7.48469C42.665 7.05831 42.1552 6.84794 41.503 6.84794C40.915 6.84794 40.4052 7.04594 39.9724 7.44531C39.5442 7.84581 39.3295 8.36444 39.3295 9.00119C39.3295 9.63794 39.5442 10.1611 39.9724 10.5616C40.4052 10.9564 40.915 11.1589 41.503 11.1589C42.1272 11.1589 42.6522 10.9564 43.0664 10.5571C43.3394 10.2927 43.4945 9.92819 43.5354 9.46244H41.503V8.81219H44.2144C44.247 8.95281 44.2564 9.08894 44.2564 9.22056Z"
        fill="white"
        stroke="white"
        strokeWidth="0.0466832"
        strokeMiterlimit="10"
      />
      <path
        d="M48.5569 6.96536H46.0101V8.67536H48.3061V9.32561H46.0101V11.0356H48.5569V11.6982H45.2891V6.30273H48.5569V6.96536Z"
        fill="white"
        stroke="white"
        strokeWidth="0.0466832"
        strokeMiterlimit="10"
      />
      <path
        d="M51.5937 11.6982H50.8727V6.96536H49.3105V6.30273H53.157V6.96536H51.5937V11.6982Z"
        fill="white"
        stroke="white"
        strokeWidth="0.0466832"
        strokeMiterlimit="10"
      />
      <path
        d="M55.9414 11.6982V6.30273H56.6612V11.6982H55.9414Z"
        fill="white"
        stroke="white"
        strokeWidth="0.0466832"
        strokeMiterlimit="10"
      />
      <path
        d="M59.8515 11.6982H59.1364V6.96536H57.5684V6.30273H61.4195V6.96536H59.8515V11.6982Z"
        fill="white"
        stroke="white"
        strokeWidth="0.0466832"
        strokeMiterlimit="10"
      />
      <path
        d="M68.701 11.0048C68.1492 11.5504 67.4655 11.8227 66.65 11.8227C65.8299 11.8227 65.1462 11.5504 64.5944 11.0048C64.0437 10.4603 63.7695 9.79206 63.7695 9.00119C63.7695 8.21031 64.0437 7.54206 64.5944 6.99756C65.1462 6.45194 65.8299 6.17969 66.65 6.17969C67.4609 6.17969 68.1445 6.45194 68.6964 7.00206C69.2517 7.55106 69.5259 8.21481 69.5259 9.00119C69.5259 9.79206 69.2517 10.4603 68.701 11.0048ZM65.1275 10.5526C65.5429 10.9564 66.048 11.1589 66.65 11.1589C67.2474 11.1589 67.7572 10.9564 68.1679 10.5526C68.582 10.1487 68.792 9.63006 68.792 9.00119C68.792 8.37231 68.582 7.85369 68.1679 7.44981C67.7572 7.04594 67.2474 6.84344 66.65 6.84344C66.048 6.84344 65.5429 7.04594 65.1275 7.44981C64.7134 7.85369 64.5034 8.37231 64.5034 9.00119C64.5034 9.63006 64.7134 10.1487 65.1275 10.5526Z"
        fill="white"
        stroke="white"
        strokeWidth="0.0466832"
        strokeMiterlimit="10"
      />
      <path
        d="M70.5371 11.6982V6.30273H71.4121L74.1328 10.499H74.1643L74.1328 9.46173V6.30273H74.8526V11.6982H74.1013L71.2523 7.29498H71.2208L71.2523 8.33673V11.6982H70.5371Z"
        fill="white"
        stroke="white"
        strokeWidth="0.0466832"
        strokeMiterlimit="10"
      />
      <path
        d="M63.5933 19.5774C61.4012 19.5774 59.6103 21.1862 59.6103 23.4058C59.6103 25.6074 61.4012 27.233 63.5933 27.233C65.7902 27.233 67.581 25.6074 67.581 23.4058C67.581 21.1862 65.7902 19.5774 63.5933 19.5774ZM63.5933 25.7255C62.3905 25.7255 61.3557 24.7682 61.3557 23.4058C61.3557 22.0254 62.3905 21.0849 63.5933 21.0849C64.7962 21.0849 65.8357 22.0254 65.8357 23.4058C65.8357 24.7682 64.7962 25.7255 63.5933 25.7255ZM54.9028 19.5774C52.706 19.5774 50.9198 21.1862 50.9198 23.4058C50.9198 25.6074 52.706 27.233 54.9028 27.233C57.0985 27.233 58.8858 25.6074 58.8858 23.4058C58.8858 21.1862 57.0985 19.5774 54.9028 19.5774ZM54.9028 25.7255C53.6988 25.7255 52.6605 24.7682 52.6605 23.4058C52.6605 22.0254 53.6988 21.0849 54.9028 21.0849C56.1057 21.0849 57.1405 22.0254 57.1405 23.4058C57.1405 24.7682 56.1057 25.7255 54.9028 25.7255ZM44.5615 20.7508V22.3776H48.59C48.4722 23.2866 48.1572 23.9548 47.6742 24.4206C47.0862 24.983 46.1703 25.6074 44.5615 25.6074C42.0824 25.6074 40.141 23.6781 40.141 21.2874C40.141 18.8968 42.0824 16.9674 44.5615 16.9674C45.902 16.9674 46.8774 17.4726 47.5972 18.1273L48.786 16.9809C47.7792 16.0539 46.4398 15.3418 44.5615 15.3418C41.1619 15.3418 38.3047 18.0092 38.3047 21.2874C38.3047 24.5657 41.1619 27.233 44.5615 27.233C46.399 27.233 47.7792 26.6525 48.8642 25.5635C49.976 24.4914 50.3225 22.9839 50.3225 21.7667C50.3225 21.3887 50.2898 21.0411 50.2315 20.7508H44.5615ZM86.8485 22.0119C86.5207 21.1558 85.5092 19.5774 83.4488 19.5774C81.4072 19.5774 79.7073 21.1288 79.7073 23.4058C79.7073 25.55 81.3897 27.233 83.6448 27.233C85.4683 27.233 86.5207 26.1609 86.9535 25.5365L85.6002 24.6669C85.1487 25.3037 84.5338 25.7255 83.6448 25.7255C82.7617 25.7255 82.1282 25.3352 81.7222 24.5657L87.0317 22.4473L86.8485 22.0119ZM81.4352 23.2865C81.3897 21.8105 82.624 21.0546 83.5083 21.0546C84.2013 21.0546 84.7893 21.3887 84.9853 21.8668L81.4352 23.2865ZM77.1197 27.0002H78.865V15.7502H77.1197V27.0002ZM74.2613 20.4302H74.203C73.811 19.9824 73.0632 19.5774 72.1158 19.5774C70.1278 19.5774 68.3102 21.2604 68.3102 23.4182C68.3102 25.5635 70.1278 27.233 72.1158 27.233C73.0632 27.233 73.811 26.8247 74.203 26.3634H74.2613V26.9124C74.2613 28.376 73.4505 29.1624 72.1427 29.1624C71.0763 29.1624 70.4148 28.4199 70.1418 27.7955L68.624 28.4064C69.0615 29.4212 70.22 30.6699 72.1427 30.6699C74.189 30.6699 75.9157 29.5089 75.9157 26.684V19.8103H74.2613V20.4302ZM72.2652 25.7255C71.0623 25.7255 70.0555 24.7547 70.0555 23.4182C70.0555 22.0693 71.0623 21.0849 72.2652 21.0849C73.4505 21.0849 74.385 22.0693 74.385 23.4182C74.385 24.7547 73.4505 25.7255 72.2652 25.7255ZM95.0198 15.7502H90.8455V27.0002H92.5862V22.7376H95.0198C96.953 22.7376 98.8488 21.3887 98.8488 19.2433C98.8488 17.0991 96.9483 15.7502 95.0198 15.7502ZM95.0653 21.1727H92.5862V17.3151H95.0653C96.365 17.3151 97.107 18.3557 97.107 19.2433C97.107 20.1141 96.365 21.1727 95.0653 21.1727ZM105.825 19.5561C104.568 19.5561 103.26 20.0916 102.722 21.2784L104.267 21.9028C104.599 21.2784 105.211 21.0759 105.857 21.0759C106.76 21.0759 107.676 21.5991 107.69 22.5227V22.6408C107.375 22.4653 106.7 22.2054 105.871 22.2054C104.207 22.2054 102.512 23.0886 102.512 24.7367C102.512 26.2442 103.875 27.215 105.407 27.215C106.578 27.215 107.224 26.7054 107.63 26.1125H107.69V26.9822H109.371V22.6667C109.371 20.6721 107.826 19.5561 105.825 19.5561ZM105.615 25.721C105.046 25.721 104.253 25.4488 104.253 24.7682C104.253 23.8974 105.242 23.5633 106.098 23.5633C106.865 23.5633 107.224 23.7264 107.69 23.9413C107.553 24.983 106.623 25.721 105.615 25.721ZM115.496 19.8024L113.495 24.6793H113.436L111.367 19.8024H109.49L112.598 26.6177L110.825 30.41H112.643L117.433 19.8024H115.496ZM99.8055 27.0002H101.551V15.7502H99.8055V27.0002Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3029_115129"
          x1="20.3465"
          y1="28.1621"
          x2="5.25234"
          y2="12.5089"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="0.0066" stopColor="#00A1FF" />
          <stop offset="0.2601" stopColor="#00BEFF" />
          <stop offset="0.5122" stopColor="#00D2FF" />
          <stop offset="0.7604" stopColor="#00DFFF" />
          <stop offset="1" stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3029_115129"
          x1="31.5785"
          y1="17.9986"
          x2="8.99472"
          y2="17.9986"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset="0.4087" stopColor="#FFBD00" />
          <stop offset="0.7754" stopColor="#FFA500" />
          <stop offset="1" stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3029_115129"
          x1="23.1728"
          y1="15.9334"
          x2="2.70384"
          y2="-5.29367"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset="1" stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3029_115129"
          x1="6.81172"
          y1="35.8414"
          x2="15.952"
          y2="26.3627"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset="0.0685" stopColor="#2DA771" />
          <stop offset="0.4762" stopColor="#15CF74" />
          <stop offset="0.8009" stopColor="#06E775" />
          <stop offset="1" stopColor="#00F076" />
        </linearGradient>
      </defs>
    </svg>
  );
}
